import smoothscroll from 'smoothscroll-polyfill';
// import IntersectionObserver from './_main/IntersectionObserver';

import { isIE } from './utility';
import { CFG } from './config';
import { Hamburger, Accordion } from './_main';
// import HamburgerMenu from './_main/HamburgerMenu';

// import DropdownMenu from './_main/DropdownMenu';
// import LoadMore from './_main/LoadMore';
// import ScrollManager from './_main/ScrollManager';
// import CookieAlert from './_main/CookieAlert';
// import Validation from './_main/Validation';
// import HeightSet from './_main/HeightSet';
// import Pagetop from './_main/Pagetop';

// import MaterialsSlides from './_home/MaterialsSlides';
// import ModalVideo from './_movies/ModalVideo';

// home
import { VisualSlides, TopicsSlides, ShopEventTab } from './_home'

// guide
import { GallerySlides } from './_guide'

{
    smoothscroll.polyfill();

    const domHamburger = document.querySelector('[data-js="trigger"]');
    if (domHamburger) new Hamburger(domHamburger);

    // const domAnchorScroll = [...document.querySelectorAll('a[href^="#"]')];
    // if ( domAnchorScroll ) {
    //     domAnchorScroll.forEach(el => {
    //         new AnchorScroll(el);
    //     });
    // }

    const domAccordion = document.querySelectorAll('[data-js="accordion"]');
    if (domAccordion) {
        [...domAccordion].forEach(el=>{
            new Accordion(el);
        })
    }
}

// {
//     const domModalVideos = document.querySelectorAll('[data-js="modal-trigger"]');
//     if (domModalVideos) {
//         new ModalVideo(domModalVideos);
//     }
// }

{
    const domVisualSlides = document.querySelector('[data-js="visual-slide"]');
    if (domVisualSlides) new VisualSlides(domVisualSlides);

    const domTopicsSlides = document.querySelector('[data-js="topics-slide"]');
    if (domTopicsSlides) new TopicsSlides(domTopicsSlides);

    const domShopEventTab = document.querySelector('[data-js="shopevent-tab"]');
    if (domShopEventTab) new ShopEventTab(domShopEventTab);
}

{
    const domGallerySlides = document.querySelector('[data-js="gallery-slide"]');
    if (domGallerySlides) new GallerySlides(domGallerySlides);
}